"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.INITIAL_PET = void 0;
var INITIAL_PET = exports.INITIAL_PET = {
  'petName': null,
  'petDOB': null,
  'day': null,
  'month': null,
  'year': null,
  'displayDate': null,
  'desexed': null,
  'gender': null,
  'genderId': null,
  'regularVetCode': null,
  'regularVet': null,
  'petNumber': 0,
  'breed': null,
  'breedCode': null,
  'crossBreed': null,
  'crossBreedCode': null,
  'species': null,
  'isCrossBreed': null,
  'speciesCode': null,
  'referenceNumber': null,
  'quotePetId': null,
  'isDentalOption': null,
  'isAssistanceDog': null,
  'petQuotes': null,
  'selectedQuote': null,
  'selectedQuoteStartDate': null,
  'petProducts': null,
  'targetMargetKnockoutSelection': null,
  'productDisclosureCoverage': null,
  'productDisclosureNonCoverage': null
};